export default __webpack_public_path__ + "static/media/LilNounsReading.eb353366.gif";